<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="!(formProps.editType === 'read')"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >编辑任务</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="任务详情"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="任务基本信息" name="baseInfo">
            <base-form :disabled="formProps.editType === 'read'" :currentRow="formData" />
          </el-collapse-item>
          <el-collapse-item title="任务周期配置" name="planUnit">
            <task-unit-config
              ref="taskUnit"
              oper="single"
              :currentRow="[formData]"
              :disabled="formProps.editType === 'read'"
            ></task-unit-config>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <el-button type="primary" size="small" @click="submitForm()" :loading="loading"
          >保存</el-button
        >
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { HiddenDangerScheduledTaskApi } from '@wiz-api/double-prevention-management'
import BaseForm from '../TimingTask/BaseForm'
import TaskUnitConfig from '../TimingTask/TaskUnitConfig'

const hiddenDangerScheduledTaskApi = new HiddenDangerScheduledTaskApi()

export default {
  name: 'timing-job-form',
  components: {
    BaseForm,
    TaskUnitConfig,
  },
  props: {
    formProps: {
      default: () => {
        return {
          editType: 'create',
        }
      },
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      collapseActiveName: ['baseInfo', 'planUnit'],
    }
  },
  methods: {
    async submitForm() {
      if (this.$refs.taskUnit.submitForm()) {
        const [err, res] = await hiddenDangerScheduledTaskApi.updateBasicManagementTroubleshooting({
          body: this.$refs.taskUnit.handleSaveData(),
        })
        if (!err) {
          this.$message({
            showClose: true,
            message: '保存设置成功',
            type: 'success',
          })
          this.$emit('refreshList')
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
